/**
 * Copyright © Veeam Software Group GmbH.
 */

import { createContext } from 'react';

import type { CurrentUsageStore } from '../stores';

export const CurrentUsageContext = createContext<CurrentUsageStore>({} as CurrentUsageStore);
